import { render, staticRenderFns } from "./selectOrder.vue?vue&type=template&id=1130f9b8&scoped=true&"
import script from "./selectOrder.vue?vue&type=script&lang=js&"
export * from "./selectOrder.vue?vue&type=script&lang=js&"
import style0 from "./selectOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./selectOrder.vue?vue&type=style&index=1&id=1130f9b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130f9b8",
  null
  
)

export default component.exports